module.exports = __webpack_public_path__ + "static/media/resume.768f3a15.pdf";